/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface TemperatureStateSignature {
  Args: {
    hasError?: boolean;
    temperature: number;
    title: string;
  };
  Element: null;
}

export default templateOnlyComponent<TemperatureStateSignature>();
